import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import Copyright from './FooterCopyright';

import '@src/css/bootstrap.scss';

import './footer.scss';

export const FooterNoData = () => (
    <footer className="footer-container no-gutters">
        <Row className="footer-row no-gutters">
            <Col sm={9} md={6} className="mx-auto footer-copyright">
                <Copyright />
            </Col>
        </Row>
    </footer>
);

export default FooterNoData;
